import axiosClient from "utils/api/axios-client";

export default {
  getRestaurantRevenue: (params) => {
    const url = "/api/v1/report/restaurant-revenue";
    return axiosClient.get(url, { params });
  },
};
